export default "__VITE_ASSET__DLhRXwwp__"